import store from "@/store";

function resolvePermissionValue(binding) {
  if (Array.isArray(binding.value)) {
    return binding.value.filter(Boolean);
  }

  if (typeof binding.value === "string" && binding.value) {
    return [binding.value];
  }

  return [];
}

function toggleElement(el, binding) {
  const permissions = resolvePermissionValue(binding);
  const allowed =
    store.getters.isSuperAdmin ||
    permissions.length === 0 ||
    store.getters.hasAnyPermission(permissions);

  if (!allowed && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export default {
  inserted(el, binding) {
    toggleElement(el, binding);
  },
};
